import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../../_models/field.interface';
@Component({
  selector: 'app-checkbox',
  template: `
    <div
      [ngClass]="field.class != null ? field.class : ''"
      [formGroup]="group"
      [ngStyle]="field.styleDivPrincipal ? field.styleDivPrincipal() : null"
    >
      <mat-checkbox
        name = "check"
        [(ngModel)]="field.value"
        [id]="field.name"
        [formControlName]="field.name"
        [ngStyle]="field.style ? field.style() : null"
      >
        <label
          [ngStyle]="
            field.styleLabelCheckBox ? field.styleLabelCheckBox() : null
          "
          class="cs_label"
          [innerHTML]="field.label | linkify"
        ></label>
      </mat-checkbox>
    </div>
  `,
  styles: [],
})
export class CheckboxComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() {}
  ngOnInit() {}
}
